import React, { useEffect } from "react"; // eslint-disable-line no-unused-vars
import { Charity, Cause } from "../../../shared/types";

export interface BreadcrumbProps {
  charity: Charity;
  cause: Cause | null | undefined;
}

export const Breadcrumb = ({
  charity,
  cause,
}: BreadcrumbProps): React.JSX.Element | null => {
  useEffect(() => {
    if (charity) {
      let elements = document.querySelectorAll(
        "div.kadence-breadcrumb-container"
      );
      if (elements.length > 0) {
        if (cause) {
          elements[0].innerHTML = `<span><a href="/" itemprop="url" class="kadence-bc-home"><span>Home</span></a></span><span class="bc-delimiter"> / </span><span><a href="/charities/" itemprop="url"><span>Charities</span></a></span><span class="bc-delimiter"> / </span><span><a href="${cause.redirect}" itemprop="url"><span>${cause.name}</span></a></span><span class="bc-delimiter"> / </span><span class="kadence-bread-current">${charity.managed.displayName}</span>`;
        } else {
          elements[0].innerHTML = `<span><a href="/" itemprop="url" class="kadence-bc-home"><span>Home</span></a></span><span class="bc-delimiter"> / </span><span><a href="/charities/" itemprop="url"><span>Charities</span></a></span><span class="bc-delimiter"> / </span><span class="kadence-bread-current">${charity.managed.displayName}</span>`;
        }
      }
    }
  }, [charity, cause]);

  return null;
};
